import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useGetBookable, LoadingResults } from 'components/api'
import ToBookPicker from 'components/bookable/ToBookPicker'
import { generateBookableBookingPath } from 'modules/bookables/routes'
import Block from 'components/layout/Block'
import NotFoundError from 'components/error/NotFoundError'

const FormWidget = ({ id, referrer }) => {
  const handleSubmitBook = useCallback(
    ({ dateRange, dateTime, guests }) => {
      window.open(
        `${generateBookableBookingPath({
          id,
          dateRange,
          dateTime,
          guests,
          referrer
        })}`,
        '_blank'
      )
    },
    [id, referrer]
  )

  const { bookable, loading } = useGetBookable({ bookableId: id })

  if (loading) {
    return <LoadingResults />
  }
  if (!bookable) {
    throw new NotFoundError('Bookable not found for id ' + id)
  }
  return (
    <Block className="ToBookPicker" variant="outline">
      <ToBookPicker bookable={bookable} onSubmit={handleSubmitBook} />
    </Block>
  )
}

FormWidget.propTypes = {
  id: PropTypes.string,
  referrer: PropTypes.string,
  host: PropTypes.string
}

FormWidget.displayName = 'FormWidget'

export default FormWidget
